import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-people',
  templateUrl: './success-people.component.html',
  styleUrls: ['./success-people.component.scss']
})
export class SuccessPeopleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
